import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {Subscription} from "rxjs/Subscription";
import {GlobalProvider} from "../../providers/global/global";
import {LocationService} from "../../store/location/location.service";
import {LocationEntity} from "../../store/location/location.entity";

/**
 * Generated class for the PruefungStandortPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pruefung-standort',
  templateUrl: 'pruefung-standort.html',
})
export class PruefungStandortPage {

  public standorte: Array<LocationEntity>;
  public editMode: number = 0;
  public newStandort: string = "";
  public editStandort: LocationEntity;
  public isOwner: boolean = false;

  private _customerId: number;
  private _customer: any;
  private _standortSubscription: Subscription;
  private _pruefung: any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private globalProvider: GlobalProvider,
              private locationService: LocationService) {
    this._customer = this.navParams.get('customer');
    this._pruefung = this.navParams.get('pruefung');
    this.isOwner = this._pruefung.ownerId === this.globalProvider.user.uuid;
    this._customerId = this._customer._id;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PruefungStandortPage');
    this._standortSubscription = this.locationService.getByCustomerId(this._customerId).subscribe((standorte) => {
      this.standorte = standorte;
    })
  }

  ionViewWillLeave() {
    this._standortSubscription.unsubscribe();
  }

  public addStandort() {
    this.locationService.add({
      customerId: this._customerId,
      docName: "Standort",
      docType: "location",
      name: name,
      deleted: false,
      system: false
    }, false);
    // this.standortProvider.add(this._customerId, this.newStandort);
    this.editMode = 0;
    this.newStandort = "";
  }

  public edit(location: LocationEntity): void {
    if (!this.isOwner)
      return;

    this.editStandort = location;
    this.editMode = 2;
  }

  public delete(): void {
    this.locationService.remove(this.editStandort, false);
    // this.dataProvider.hardDeleteDocument(this.editStandort);
    this.editStandort = null;
    this.editMode = 0;
  }

  public cancel(): void {
    this.editMode = 0;
    this.newStandort = "";
  }

  public save(name): void {
    this.editStandort.name = name;
    // this.dataProvider.updateDocument(this.editStandort);
    this.locationService.set(this.editStandort, false);
    this.editMode = 0;
  }
}



// WEBPACK FOOTER //
// ./src/pages/pruefung-standort/pruefung-standort.ts